import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/')({});